import { FeatureId } from '@/core/feature-flags/enums';

import { getFeatureDetails } from './utils';

/** Индикатор ограниченной функции: в ShbDeployer ничего не отображает. */
export default class BeIndicatorController {
  limitedToBE?: boolean;

  feature?: FeatureId;

  /* @ngInject */
  constructor() {
    this.limitedToBE = false;
  }

  $onInit() {
    const { limitedToBE } = getFeatureDetails(this.feature);

    this.limitedToBE = limitedToBE;
  }
}
